import { RegisterResponse } from 'api';

const hasValue = (value?: string | null) => !!value?.trim();

export const hasIncompleteRegistrationFields = (registerObj: RegisterResponse | undefined): boolean => {
  if (!registerObj) return false;
  return (
    !hasValue(registerObj.ACN) ||
    !hasValue(registerObj.abn) ||
    !hasValue(registerObj.trustee) ||
    !hasValue(registerObj.registered_office)
  );
};
